<div class="mapViewWrapper" style="height: calc(100% - 10px); margin: 5px;">
    <div class="innerMapView" style="height: 100%; margin-bottom: 20px;">
        <iframe *ngIf="gpsLoaction != ''" [src]="gpsLoaction | safe" width="100%" height="100%"
            frameborder="0" style="border: 0; margin: 0px auto; display: block;" allowfullscreen=""
            aria-hidden="false" tabindex="0"></iframe>
    </div>
</div>